var render = function () {
  var _vm$orderData$service, _vm$orderData$service2, _vm$user, _vm$user2;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "ongkir-create-order pb-20 pt-6 px-4 md:px-6 bg-neutral-50 min-h-screen"
  }, [_c('div', {
    staticClass: "max-w-6xl mx-auto"
  }, [_c('div', {
    staticClass: "flex flex-col lg:flex-row gap-6 items-start"
  }, [_c('div', {
    staticClass: "w-full lg:w-2/3"
  }, [_c('div', {
    staticClass: "bg-white rounded-xl shadow-sm border border-neutral-200 p-6 mb-6 relative overflow-hidden"
  }, [_c('div', {
    staticClass: "absolute left-0 top-0 bottom-0 w-1 bg-red-600"
  }), _c('p', {
    staticClass: "text-lg font-bold text-red-600 mb-5 pl-2"
  }, [_vm._v("Informasi Pengirim dan Penerima")]), _c('div', {
    staticClass: "mb-6"
  }, [_c('p', {
    staticClass: "text-sm text-neutral-500 mb-4 font-medium"
  }, [_vm._v("Pengirim")]), _c('div', {
    staticClass: "mb-4"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 mb-1 inline-block"
  }, [_vm._v("Area (Otomatis Terisi)")]), _c('div', {
    staticClass: "w-full px-3 py-2.5 rounded-lg border border-neutral-200 bg-neutral-100 text-neutral-600 focus:outline-none"
  }, [_vm._v(" " + _vm._s(_vm.orderData.originSearch || '-') + " ")])]), _c('div', {
    staticClass: "mb-4"
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.sender_name,
      expression: "form.sender_name"
    }],
    staticClass: "w-full px-3 py-2.5 rounded-lg border border-neutral-300 focus:outline-none focus:border-primary-500 focus:ring-1 focus:ring-primary-500 transition-colors",
    attrs: {
      "type": "text",
      "placeholder": "Contoh: Linknau"
    },
    domProps: {
      "value": _vm.form.sender_name
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.form, "sender_name", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "mb-4"
  }, [_vm._m(1), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.sender_phone,
      expression: "form.sender_phone"
    }],
    staticClass: "w-full px-3 py-2.5 rounded-lg border border-neutral-300 focus:outline-none focus:border-primary-500 focus:ring-1 focus:ring-primary-500 transition-colors",
    attrs: {
      "type": "text",
      "placeholder": "Contoh: 08123456789"
    },
    domProps: {
      "value": _vm.form.sender_phone
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.form, "sender_phone", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "mb-2"
  }, [_vm._m(2), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.sender_address,
      expression: "form.sender_address"
    }],
    staticClass: "w-full px-3 py-2.5 rounded-lg border border-neutral-300 focus:outline-none focus:border-primary-500 focus:ring-1 focus:ring-primary-500 transition-colors resize-none",
    attrs: {
      "placeholder": "Tulis alamat detail (nama jalan, patokan, dll)",
      "rows": "3"
    },
    domProps: {
      "value": _vm.form.sender_address
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.form, "sender_address", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "border-t border-neutral-100 pt-5"
  }, [_c('p', {
    staticClass: "text-sm text-neutral-500 mb-4 font-medium"
  }, [_vm._v("Penerima")]), _c('div', {
    staticClass: "mb-4"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 mb-1 inline-block"
  }, [_vm._v("Area (Otomatis Terisi)")]), _c('div', {
    staticClass: "w-full px-3 py-2.5 rounded-lg border border-neutral-200 bg-neutral-100 text-neutral-600 focus:outline-none"
  }, [_vm._v(" " + _vm._s(_vm.orderData.destinationSearch || '-') + " ")])]), _c('div', {
    staticClass: "mb-4"
  }, [_vm._m(3), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.receiver_name,
      expression: "form.receiver_name"
    }],
    staticClass: "w-full px-3 py-2.5 rounded-lg border border-neutral-300 focus:outline-none focus:border-primary-500 focus:ring-1 focus:ring-primary-500 transition-colors",
    attrs: {
      "type": "text",
      "placeholder": "Contoh: Budi"
    },
    domProps: {
      "value": _vm.form.receiver_name
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.form, "receiver_name", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "mb-4"
  }, [_vm._m(4), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.receiver_phone,
      expression: "form.receiver_phone"
    }],
    staticClass: "w-full px-3 py-2.5 rounded-lg border border-neutral-300 focus:outline-none focus:border-primary-500 focus:ring-1 focus:ring-primary-500 transition-colors",
    attrs: {
      "type": "text",
      "placeholder": "Contoh: 08123456789"
    },
    domProps: {
      "value": _vm.form.receiver_phone
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.form, "receiver_phone", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "mb-2"
  }, [_vm._m(5), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.receiver_address,
      expression: "form.receiver_address"
    }],
    staticClass: "w-full px-3 py-2.5 rounded-lg border border-neutral-300 focus:outline-none focus:border-primary-500 focus:ring-1 focus:ring-primary-500 transition-colors resize-none",
    attrs: {
      "placeholder": "Tulis alamat detail (nama jalan, patokan, dll)",
      "rows": "3"
    },
    domProps: {
      "value": _vm.form.receiver_address
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.form, "receiver_address", $event.target.value);
      }
    }
  })])])])]), _c('div', {
    staticClass: "w-full lg:w-1/3"
  }, [_c('div', {
    staticClass: "bg-white rounded-xl shadow-sm border border-neutral-200 p-6 mb-6"
  }, [_c('p', {
    staticClass: "text-lg font-bold text-neutral-800 mb-5"
  }, [_vm._v("Informasi Layanan")]), _c('div', {
    staticClass: "mb-5 border-b border-neutral-100 pb-5"
  }, [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('div', {
    staticClass: "flex items-center gap-3"
  }, [_c('div', {
    staticClass: "w-16 h-12 bg-neutral-50 border border-neutral-100 rounded-md flex items-center justify-center p-1"
  }, [_vm.orderData.service && _vm.orderData.service.logo ? _c('img', {
    staticClass: "max-h-8 object-contain",
    attrs: {
      "src": _vm.orderData.service ? _vm.orderData.service.logo : '',
      "alt": "Logo"
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "flex flex-col gap-1"
  }, [_c('p', {
    staticClass: "font-bold text-neutral-800"
  }, [_vm._v(_vm._s(_vm.orderData.service ? _vm.orderData.service.name : '-'))]), _c('p', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v(_vm._s(_vm.orderData.service ? _vm.orderData.service.package.name : '-'))])])]), _c('p', {
    staticClass: "font-bold text-lg text-neutral-800"
  }, [_vm._v(_vm._s(_vm.orderData.service ? _vm.$options.filters.currencyFormat(_vm.orderData.service.package.final_cost) : 'Rp 0'))])])]), _c('div', {
    staticClass: "mb-5 border-b border-neutral-100 pb-5 custom-select"
  }, [_vm._m(6), _c('v-select', {
    staticClass: "v-select-custom",
    attrs: {
      "options": _vm.goodsCategories,
      "placeholder": "Pilih jenis paket",
      "reduce": function reduce(selectedPackage) {
        return selectedPackage.code;
      },
      "label": "name"
    },
    model: {
      value: _vm.form.goods_content,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "goods_content", $$v);
      },
      expression: "form.goods_content"
    }
  })], 1), _c('div', [_c('div', {
    staticClass: "flex justify-between items-center mb-4"
  }, [_c('p', {
    staticClass: "text-sm text-neutral-500 font-medium"
  }, [_vm._v("Dimensi Paket")]), _c('div', {
    staticClass: "bg-teal-50 px-3 py-1 rounded-full border border-teal-100 text-teal-700 text-sm font-medium"
  }, [_vm._v(" Berat Aktual: " + _vm._s(_vm.orderData.package_weight ? _vm.orderData.package_weight + ' Kg' : '-') + " ")])]), _c('div', {
    staticClass: "flex gap-3 mb-4"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_vm._m(7), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.length,
      expression: "form.length"
    }],
    staticClass: "w-full px-3 py-2 rounded-lg border border-neutral-300 focus:outline-none focus:border-primary-500 text-sm",
    attrs: {
      "type": "number",
      "placeholder": "P"
    },
    domProps: {
      "value": _vm.form.length
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.form, "length", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "flex-1"
  }, [_vm._m(8), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.width,
      expression: "form.width"
    }],
    staticClass: "w-full px-3 py-2 rounded-lg border border-neutral-300 focus:outline-none focus:border-primary-500 text-sm",
    attrs: {
      "type": "number",
      "placeholder": "L"
    },
    domProps: {
      "value": _vm.form.width
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.form, "width", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "flex-1"
  }, [_vm._m(9), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.height,
      expression: "form.height"
    }],
    staticClass: "w-full px-3 py-2 rounded-lg border border-neutral-300 focus:outline-none focus:border-primary-500 text-sm",
    attrs: {
      "type": "number",
      "placeholder": "T"
    },
    domProps: {
      "value": _vm.form.height
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.form, "height", $event.target.value);
      }
    }
  })])]), _vm.volumeWeight > 0 ? _c('div', {
    staticClass: "flex justify-between items-center mb-4 bg-neutral-50 px-3 py-2 rounded-lg border border-neutral-100"
  }, [_c('p', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v("Berat Volume")]), _c('p', {
    staticClass: "text-sm font-bold text-neutral-700"
  }, [_vm._v(_vm._s(_vm.volumeWeight) + " Kg")])]) : _vm._e()])]), _c('div', {
    staticClass: "flex justify-end mt-6"
  }, [_c('Button', {
    class: 'big_full',
    attrs: {
      "buttonText": "Lanjutkan",
      "type": "primary",
      "disabled": !_vm.isValidForm
    },
    on: {
      "action": _vm.submitOrderModal
    }
  })], 1)])])]), _c('Modal', {
    attrs: {
      "modalVisible": _vm.visibleVolumeModal,
      "id": "volume-confirmation-modal"
    },
    on: {
      "close": _vm.closeVolumeModal
    }
  }, [_c('template', {
    slot: "modal-content"
  }, [_c('div', {
    staticClass: "p-6"
  }, [_c('p', {
    staticClass: "text-sm text-neutral-600 mb-6"
  }, [_vm._v(" Berat volume ("), _c('strong', [_vm._v(_vm._s(_vm.volumeWeight) + " Kg")]), _vm._v(") melebihi berat aktual ("), _c('strong', [_vm._v(_vm._s(_vm.orderData.package_weight) + " Kg")]), _vm._v("), apakah Anda ingin melanjutkan untuk memperbarui harga ongkir ? ")]), _c('div', {
    staticClass: "flex justify-end gap-3"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Batal",
      "type": "secondary"
    },
    on: {
      "action": _vm.closeVolumeModal
    }
  }), _c('Button', {
    attrs: {
      "buttonText": "Lanjutkan",
      "type": "primary",
      "disabled": _vm.recheckLoading
    },
    on: {
      "action": _vm.proceedVolumeWeight
    }
  })], 1)])])], 2), _c('Modal', {
    attrs: {
      "modalVisible": _vm.showCheckoutModal,
      "id": "checkout-modal",
      "width": "550px",
      "overflowAuto": true
    },
    on: {
      "close": function close($event) {
        _vm.showCheckoutModal = false;
      }
    }
  }, [_c('template', {
    slot: "modal-content"
  }, [_c('div', {
    staticClass: "flex justify-between items-center mb-6 border-b border-neutral-200 pb-4"
  }, [_c('p', {
    staticClass: "font-bold text-xl text-neutral-800"
  }, [_vm._v("Rincian & Pembayaran")])]), _vm.orderData.service ? _c('div', {
    staticClass: "border border-gray-300 mb-6 rounded-xl p-4 bg-white shadow-sm flex justify-between items-center"
  }, [_c('div', {
    staticClass: "flex items-center gap-4"
  }, [_c('div', {
    staticClass: "w-16 h-12 bg-neutral-50 border border-neutral-100 rounded-md flex items-center justify-center p-1"
  }, [_vm.orderData.service.logo ? _c('img', {
    staticClass: "max-h-10 object-contain",
    attrs: {
      "src": _vm.orderData.service.logo
    }
  }) : _c('LogisticPlaceholder', {
    attrs: {
      "logisticName": _vm.orderData.service.name
    }
  })], 1), _c('div', [_c('p', {
    staticClass: "font-bold text-neutral-800 text-sm"
  }, [_vm._v(_vm._s(_vm.orderData.service.package.name))]), _c('p', {
    staticClass: "text-xs text-neutral-500 mt-1 flex items-center gap-1 font-medium"
  }, [_c('Time', {
    attrs: {
      "width": "12",
      "height": "12",
      "color": "neutral-500"
    }
  }), _vm._v(" " + _vm._s(_vm.orderData.service.package.est_delivery_time_range_min) + " - " + _vm._s(_vm.orderData.service.package.est_delivery_time_range_max) + " ")], 1)])]), _c('div', {
    staticClass: "text-right"
  }, [_c('p', {
    staticClass: "text-base font-bold text-primary-600"
  }, [_vm._v(_vm._s(_vm._f("currencyFormat")(_vm.orderData.service.package.final_cost)))])])]) : _vm._e(), _vm.orderData.service && _vm.orderData.service.package.has_insurace ? _c('div', {
    staticClass: "border border-gray-300 mb-6 rounded-xl overflow-hidden shadow-sm bg-white"
  }, [_c('div', {
    staticClass: "p-4 flex justify-between items-center gap-4",
    class: {
      'border-b border-gray-300 bg-neutral-50': _vm.insurance
    }
  }, [_c('div', {
    staticClass: "flex flex-col flex-1"
  }, [_c('p', {
    staticClass: "text-sm font-bold text-neutral-800"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepTwo.insurance')))]), !_vm.insurance ? _c('p', {
    staticClass: "text-xs text-neutral-500 mt-1"
  }, [_vm._v("Lindungi paket dari kerusakan/kehilangan")]) : _vm._e()]), _c('div', {
    staticClass: "w-12 flex-shrink-0 flex justify-end"
  }, [_c('Toggle', {
    attrs: {
      "id": "insurance"
    },
    model: {
      value: _vm.insurance,
      callback: function callback($$v) {
        _vm.insurance = $$v;
      },
      expression: "insurance"
    }
  })], 1)]), _vm.insurance ? _c('div', {
    staticClass: "p-4 bg-white"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-2 block"
  }, [_vm._v(" " + _vm._s(_vm.$t('order.createOrder.stepTwo.goodsValue')) + " ")]), _c('CurrencyInput', {
    ref: 'priceField',
    attrs: {
      "options": {
        currency: 'IDR'
      },
      "placeholder": _vm.$t('order.createOrder.stepTwo.goodsValuePlaceholder')
    },
    on: {
      "change": function change($event) {
        _vm.goodsValue = $event;
      }
    }
  }), _c('div', {
    staticClass: "mt-4 pt-4 border-t border-dashed border-neutral-200 flex justify-between items-center"
  }, [_c('p', {
    staticClass: "text-sm text-neutral-600"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepTwo.insuranceCost')))]), _c('p', {
    staticClass: "text-sm font-bold text-neutral-800"
  }, [_vm._v(_vm._s(_vm._f("currencyFormat")(_vm.costOfInsurance)))])])], 1) : _vm._e()]) : _vm._e(), _c('div', {
    staticClass: "border border-gray-300 mb-6 rounded-xl p-4 bg-white shadow-sm"
  }, [_c('p', {
    staticClass: "font-bold text-sm mb-4 text-neutral-800"
  }, [_vm._v("Rincian Biaya")]), _c('div', {
    staticClass: "flex justify-between items-center mb-3"
  }, [_c('p', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v("Layanan Pengiriman")]), _c('p', {
    staticClass: "text-sm font-medium text-neutral-800"
  }, [_vm._v(_vm._s(_vm._f("currencyFormat")((_vm$orderData$service = _vm.orderData.service) === null || _vm$orderData$service === void 0 ? void 0 : (_vm$orderData$service2 = _vm$orderData$service.package) === null || _vm$orderData$service2 === void 0 ? void 0 : _vm$orderData$service2.final_cost)))])]), _vm.insurance ? _c('div', {
    staticClass: "flex justify-between items-center mb-3"
  }, [_c('p', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v("Biaya Asuransi")]), _c('p', {
    staticClass: "text-sm font-medium text-neutral-800"
  }, [_vm._v(_vm._s(_vm._f("currencyFormat")(_vm.costOfInsurance)))])]) : _vm._e(), _c('div', {
    staticClass: "border-t border-gray-300 mt-4 pt-4 flex justify-between items-center bg-primary-50 -mx-4 -mb-4 px-4 py-3 rounded-b-xl"
  }, [_c('p', {
    staticClass: "font-bold text-neutral-800"
  }, [_vm._v("Total Pembayaran")]), _c('p', {
    staticClass: "font-bold text-lg text-primary-600"
  }, [_vm._v(_vm._s(_vm._f("currencyFormat")(_vm.totalCost)))])])]), !((_vm$user = _vm.user) !== null && _vm$user !== void 0 && _vm$user.is_upgraded) ? _c('div', {
    staticClass: "mb-6"
  }, [_c('p', {
    staticClass: "font-bold text-sm mb-3 text-neutral-800"
  }, [_vm._v("Metode Pembayaran")]), _c('div', {
    staticClass: "flex gap-4"
  }, [_c('div', {
    staticClass: "border rounded-xl p-4 flex-1 flex items-center justify-center cursor-pointer transition-all duration-200 hover:shadow-md",
    class: {
      'border-primary-500 bg-primary-50 ring-2 ring-primary-500 ring-opacity-50': _vm.paymentType === 'qris',
      'border-gray-300 bg-white hover:border-primary-300': _vm.paymentType !== 'qris'
    },
    on: {
      "click": function click($event) {
        _vm.paymentType = 'qris';
      }
    }
  }, [_c('label', {
    staticClass: "flex flex-col items-center gap-2 w-full cursor-pointer"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.paymentType,
      expression: "paymentType"
    }],
    staticClass: "hidden",
    attrs: {
      "type": "radio",
      "name": "paymentTypeModal",
      "value": "qris"
    },
    domProps: {
      "checked": _vm._q(_vm.paymentType, "qris")
    },
    on: {
      "change": function change($event) {
        _vm.paymentType = "qris";
      }
    }
  }), _c('img', {
    staticClass: "h-6 object-contain",
    attrs: {
      "src": require("@/assets/images/icons/qris.svg")
    }
  }), _c('span', {
    staticClass: "text-xs font-medium text-neutral-600",
    class: {
      'text-primary-700': _vm.paymentType === 'qris'
    }
  }, [_vm._v("QRIS")])])]), _c('div', {
    staticClass: "border rounded-xl p-4 flex-1 flex flex-col justify-center cursor-pointer transition-all duration-200 hover:shadow-md",
    class: {
      'border-primary-500 bg-primary-50 ring-2 ring-primary-500 ring-opacity-50': _vm.paymentType === 'transfer',
      'opacity-50 cursor-not-allowed bg-neutral-50': _vm.totalCost < 80000,
      'border-gray-300 bg-white hover:border-primary-300': _vm.paymentType !== 'transfer' && _vm.totalCost >= 80000
    },
    on: {
      "click": function click($event) {
        _vm.totalCost >= 80000 ? _vm.paymentType = 'transfer' : null;
      }
    }
  }, [_c('label', {
    staticClass: "flex flex-col items-center gap-2 w-full cursor-pointer",
    class: {
      'cursor-not-allowed': _vm.totalCost < 80000
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.paymentType,
      expression: "paymentType"
    }],
    staticClass: "hidden",
    attrs: {
      "disabled": _vm.totalCost < 80000,
      "type": "radio",
      "name": "paymentTypeModal",
      "value": "transfer"
    },
    domProps: {
      "checked": _vm._q(_vm.paymentType, "transfer")
    },
    on: {
      "change": function change($event) {
        _vm.paymentType = "transfer";
      }
    }
  }), _c('span', {
    staticClass: "font-bold text-sm text-neutral-700",
    class: {
      'text-primary-700': _vm.paymentType === 'transfer'
    }
  }, [_vm._v("Bank Transfer")])]), _vm.totalCost < 80000 ? _c('p', {
    staticClass: "text-red-500 text-[10px] mt-1 text-center w-full"
  }, [_vm._v(" Min. Belanja Rp 80.000 ")]) : _vm._e()])])]) : _vm._e(), _c('div', {
    staticClass: "mt-4 pt-6 pb-2 border-t border-gray-200"
  }, [_c('Button', {
    attrs: {
      "disabled": !((_vm$user2 = _vm.user) !== null && _vm$user2 !== void 0 && _vm$user2.is_upgraded) && !_vm.paymentType,
      "buttonText": "Lanjutkan Pembayaran",
      "type": "primary",
      "size": "big_full"
    },
    on: {
      "action": function action($event) {
        return _vm.processSubmitOrder();
      }
    }
  })], 1)])], 2)], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "text-sm text-neutral-700 mb-1 inline-block"
  }, [_vm._v("Nama "), _c('span', {
    staticClass: "text-red-500"
  }, [_vm._v("*")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "text-sm text-neutral-700 mb-1 inline-block"
  }, [_vm._v("No. Handphone "), _c('span', {
    staticClass: "text-red-500"
  }, [_vm._v("*")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "text-sm text-neutral-700 mb-1 inline-block"
  }, [_vm._v("Alamat "), _c('span', {
    staticClass: "text-red-500"
  }, [_vm._v("*")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "text-sm text-neutral-700 mb-1 inline-block"
  }, [_vm._v("Nama "), _c('span', {
    staticClass: "text-red-500"
  }, [_vm._v("*")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "text-sm text-neutral-700 mb-1 inline-block"
  }, [_vm._v("No. Handphone "), _c('span', {
    staticClass: "text-red-500"
  }, [_vm._v("*")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "text-sm text-neutral-700 mb-1 inline-block"
  }, [_vm._v("Alamat "), _c('span', {
    staticClass: "text-red-500"
  }, [_vm._v("*")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "text-sm text-neutral-700 mb-2 inline-block"
  }, [_vm._v("Jenis Paket "), _c('span', {
    staticClass: "text-red-500"
  }, [_vm._v("*")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "text-xs text-neutral-500 mb-1 block"
  }, [_vm._v("Panjang (cm) "), _c('span', {
    staticClass: "text-red-500"
  }, [_vm._v("*")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "text-xs text-neutral-500 mb-1 block"
  }, [_vm._v("Lebar (cm) "), _c('span', {
    staticClass: "text-red-500"
  }, [_vm._v("*")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "text-xs text-neutral-500 mb-1 block"
  }, [_vm._v("Tinggi (cm) "), _c('span', {
    staticClass: "text-red-500"
  }, [_vm._v("*")])]);
}]

export { render, staticRenderFns }